module.exports = __webpack_public_path__ + "static/media/tier-7.8a9c7e73.jpg";